import { isFeatureFlagEnable } from '../api/unleash'
import { createHubSpotVisitorIdentification } from '../actions/hubspot'
import { UnleashToggles } from '../types/unleashToggles'

export const isHubSpotIntegrationEnabled = () => {
  return isFeatureFlagEnable(UnleashToggles.HUBSPOT_INTEGRATION)
}

export const initHubSpot = (dispatch, employee) => {
  if (!isHubSpotLoaded()) {
    if (employee) {
      dispatch(createHubSpotVisitorIdentification(employee))
    } else {
      loadHubSpot()
    }
  }
}

export const setHubSpotConversationSettings = (loadImmediately, email = '', token = '') => {
  window.hsConversationsSettings = {
    loadImmediately: loadImmediately,
    identificationEmail: email,
    identificationToken: token,
  }

  if (!loadImmediately) loadHubSpot()
}

export const isHubSpotLoaded = () => {
  const status = window.HubSpotConversations && window.HubSpotConversations.widget.status()
  const loaded = status ? status.loaded : false
  return loaded
}

export const loadHubSpot = () => {
  if (window.HubSpotConversations) {
    const loaded = isHubSpotLoaded()
    if (loaded) {
      window.HubSpotConversations.widget.refresh()
    } else {
      window.HubSpotConversations.widget.load()
    }
  } else {
    setHubSpotConversationSettings(true)
  }
}

export const clearHubSpot = () => {
  setHubSpotConversationSettings(false)
  if (window.HubSpotConversations) {
    window.HubSpotConversations.clear({ resetWidget: true })
  }
}

export const initChatWidget = (dispatch, employee) => {
  isHubSpotIntegrationEnabled().then((enabled) => {
    if (enabled) {
      hideZendesk()
      initHubSpot(dispatch, employee)
    } else {
      showZendesk()
    }
  })
}

export const hideZendesk = () => {
  window.HubSpotConversations.widget.remove()
}

export const showZendesk = () => {
  window.HubSpotConversations.widget.load()
}



// WEBPACK FOOTER //
// ./src/utils/crm.js